import { render, staticRenderFns } from "./abnormalShutdown.vue?vue&type=template&id=870ef498&scoped=true&"
import script from "./abnormalShutdown.vue?vue&type=script&lang=js&"
export * from "./abnormalShutdown.vue?vue&type=script&lang=js&"
import style0 from "./abnormalShutdown.vue?vue&type=style&index=0&id=870ef498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870ef498",
  null
  
)

export default component.exports